import React, { Fragment } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { withRouter } from 'react-router-dom';

/**
 * Accounting-Component
 *
 * @returns {JSX.Element} Accounting-Component
 * @constructor
 */
const Accounting = () => {
  return (
    <Fragment>
      <div className='accounting-wrapper'>
        <GridCellWrapper
          classes='accounting'
          label='Accounting'
          saveUserAnsicht={() => {
            null;
          }}
        >
          Accounting
        </GridCellWrapper>
      </div>
    </Fragment>
  );
};

export default withRouter(Accounting);
